import { render, staticRenderFns } from "./AgreementRegister.vue?vue&type=template&id=3c51489d"
import script from "./AgreementRegister.vue?vue&type=script&lang=js"
export * from "./AgreementRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports